import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserPermissions } from '../hooks/useUserPermissions.jsx';

/**
 * Client-side gate for a route, admitting any of the listed Cognito groups.
 * UX only — real security is each model's @auth rules, which deny the
 * underlying query regardless of what the client renders.
 *
 * Generalised from RequireAdminAccess so /admin can admit adminAccess OR
 * catalogAuthor while each child route states its own requirement, instead of
 * growing a bespoke guard component per group.
 */
export function RequireGroup({ user, anyOf, children }) {
  const { userGroups, isCheckingAccess } = useUserPermissions(user);

  // Don't redirect before Cognito groups resolve — that would bounce legitimate users.
  if (isCheckingAccess) {
    return <div className="p-4 bg-black min-h-screen text-white">Checking access...</div>;
  }
  if (!anyOf.some((g) => userGroups.includes(g))) return <Navigate to="/" replace />;
  return children;
}

export default RequireGroup;
